import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './views/Home';
import Trailers from './views/Trailers';
import About from './views/About';
import Contact from './views/Contact';
import SmsOptIn from './views/SmsOptIn';
import PrivacyPolicy from './views/PrivacyPolicy';
import Terms from './views/Terms';
import SmsTerms from './views/SmsTerms';
import SignUp from './views/SignUp';
import NotFound from './views/NotFound';
import Redirect from './views/Redirect';
import { ROUTES } from './config/company';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path={ROUTES.home} element={<Home />} />
          <Route path={ROUTES.trailers} element={<Trailers />} />
          <Route path={ROUTES.about} element={<About />} />
          <Route path={ROUTES.contact} element={<Contact />} />
          <Route path={ROUTES.smsOptIn} element={<SmsOptIn />} />
          <Route path={ROUTES.privacy} element={<PrivacyPolicy />} />
          <Route path={ROUTES.terms} element={<Terms />} />
          <Route path={ROUTES.smsTerms} element={<SmsTerms />} />
          <Route path={ROUTES.signup} element={<SignUp />} />
          <Route path={ROUTES.signin} element={<Redirect to={ROUTES.contact} />} />
          <Route path={ROUTES.admin} element={<Redirect to={ROUTES.contact} />} />

          {/* Legacy URLs from the previous site keep working */}
          <Route path="/services" element={<Redirect to={ROUTES.trailers} />} />
          <Route path="/contact-us" element={<Redirect to={ROUTES.contact} />} />
          <Route path="/contact-Us" element={<Redirect to={ROUTES.contact} />} />
          <Route path="/tc" element={<Redirect to={ROUTES.terms} />} />
          <Route path="/packages" element={<Redirect to={ROUTES.trailers} />} />
          <Route path="/advantages" element={<Redirect to={ROUTES.about} />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
